import { render } from "./MapCustomAreaInfo.vue?vue&type=template&id=c0c72c94"
import script from "./MapCustomAreaInfo.vue?vue&type=script&lang=js"
export * from "./MapCustomAreaInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__